import React, { useState } from 'react';
import Stage from './Stage';
import Display from './Display';
import StartButton from './StartButton';
import ControlButton from './ControlButton';
import { createStage, checkCollision } from '../gameHelpers';
import { StyledTetrisWrapper, StyledTetris } from './styles/StyledTetris';
import { StyledDisplayWrapper } from './styles/StyledDisplay';
import { StyledControlButtonsWrapper } from './styles/StyledControlButton';
import { useInterval } from '../hooks/useInterval';
import { usePlayer } from '../hooks/usePlayer';
import { useStage } from '../hooks/useStage';
import { useGameStatus } from '../hooks/useGameStatus';

const Tetris = () => {
  const [dropTime, setDropTime] = useState(null);
  const [gameOver, setGameOver] = useState(false);
  const [player, updatePlayerPos, resetPlayer, playerRotate] = usePlayer();
  const [stage, setStage, rowsCleared] = useStage(player, resetPlayer);
  const [score, setScore, rows, setRows, level, setLevel] = useGameStatus(rowsCleared);
  const movePlayer = dir => {
    if (!checkCollision(player, stage, { x: dir, y: 0 })) {
      updatePlayerPos({ x: dir, y: 0 });
    }
  };

  const startGame = () => {
    setStage(createStage());
    setDropTime(1000);
    resetPlayer();
    setGameOver(false);
    setScore(0);
    setRows(0);
    setLevel(0);
  };

  const drop = () => {
    if (rows > (level + 1) * 10) {
      setLevel(prev => prev + 1);
      setDropTime(1000 / (level + 1) + 200);
    }

    if (!checkCollision(player, stage, { x: 0, y: 1 })) {
      updatePlayerPos({ x: 0, y: 1, collided: false });
    } else {
      if (player.pos.y < 1) {
        setGameOver(true);
        setDropTime(null);
      }

      updatePlayerPos({ x: 0, y: 0, collided: true });
    }
  };

  const keyUp = ({ keyCode }) => {
    if (!gameOver) {
      if (keyCode === 40) {
        setDropTime(1000 / (level + 1) + 200);
      }
    }
  };

  const dropPlayer = () => {
    setDropTime(null);
    drop();
  };


  const move = ({ keyCode }) => {
    if (!gameOver) {
      if (keyCode === 37) {
        movePlayer(-1);
      } else if (keyCode === 39) {
        movePlayer(1);
      } else if (keyCode === 40) {
        dropPlayer();
      } else if (keyCode === 38) {
        playerRotate(stage, 1);
      }
    }
  };

  const handleLeftButtonClick = () => {
    if (!gameOver) {
      movePlayer(-1);
    }
  };

  const handleRightButtonClick = () => {
    if (!gameOver) {
      movePlayer(1);
    }
  };

  const handleDownButtonClick = () => {
    if (!gameOver) {
      dropPlayer();
      setDropTime(1000 / (level + 1) + 200);
    }
  };

  const handleRotateButtonClick = () => {
    if (!gameOver) {
      playerRotate(stage, 1);
    }
  };

  useInterval(() => {
    drop();
  }, dropTime);

  return (
    <StyledTetrisWrapper role="button" tabIndex="0" onKeyDown={e => move(e)} onKeyUp={keyUp}>
      <StyledTetris>
        <Stage stage={stage} />
        <aside>
          {gameOver ?
          <Display gameOver={gameOver} text="Game Over" /> :
          <StyledDisplayWrapper>
            <Display text={`Score: ${score}`} />
            <Display text={`Rows: ${rows}`} />
            <Display text={`Level: ${level}`} />
          </StyledDisplayWrapper>}
          <StartButton callback={startGame} />
        </aside>
        <StyledControlButtonsWrapper>
          <ControlButton icon="fa-chevron-left" onClick={handleLeftButtonClick} />
          <ControlButton icon="fa-chevron-down" onClick={handleDownButtonClick} />
          <ControlButton icon="fa-chevron-right" onClick={handleRightButtonClick} />
          <ControlButton icon="fa-rotate-right" onClick={handleRotateButtonClick} />
        </StyledControlButtonsWrapper>
     </StyledTetris>
    </StyledTetrisWrapper>
  );
};

export default Tetris;

